module.exports = __webpack_public_path__ + "static/img/adobe_reader.2558e095.png";